import React, { FC } from 'react';
import styles from './text.module.scss';

type Props = {
  text: string;
};

export const TruncatedDefinition: FC<Props> = ({ children, text }) => (
  <div className={styles.container}>
    <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
    {children}
  </div>
);
